import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';

import { ApolloProvider } from '@apollo/client';
import { loadSentry } from '@opendoor/observability';
import '@opendoor/primer/stylesheets/primer.css';
import { loadGoogleTagManager } from '@opendoor/shared-fe/build/googleTagManager';
import { loadSegment } from '@opendoor/shared-fe/build/segment';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

import App from './App';
import { productionClient } from './config/apolloClients';
import { SessionContext, Sessions } from './config/context';
import { PartnerContextProvider } from './config/PartnerContext';
import './styles/index.less';

// https://sentry.io/settings/opendoor/projects/partnership-dashboard-fe/keys/
const RAVEN_URL = 'https://bc50f25b43e24d70abc6cf650d88de80@o117144.ingest.sentry.io/1382664';
loadSentry(RAVEN_URL);

loadGoogleTagManager();
loadSegment();
const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <ApolloProvider client={productionClient}>
    <SessionContext.Provider value={Sessions}>
      <PartnerContextProvider>
        <App />
      </PartnerContextProvider>
    </SessionContext.Provider>
  </ApolloProvider>,
);
ReactModal.setAppElement('#root');
